var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "heading-tabs" },
    [
      _vm.type === "vuerouter"
        ? _vm._l(_vm.tabs, function(link) {
            return _c(
              "router-link",
              {
                key: link.name,
                staticClass:
                  "heading-tabs__link typographies-paragraph-medium-semibold",
                attrs: {
                  to: { name: link.name },
                  activeClass: "heading-tabs__link--is-active",
                  exact: ""
                }
              },
              [_vm._v("\n            " + _vm._s(link.label) + "\n        ")]
            )
          })
        : _vm._l(_vm.tabs, function(tab) {
            return _c(
              "div",
              {
                key: tab.id,
                staticClass:
                  "heading-tabs__link typographies-paragraph-medium-semibold",
                class: {
                  "heading-tabs__link--is-active": tab.id === _vm.activeTab
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("tab-clicked", tab.id)
                  }
                }
              },
              [_vm._v("\n            " + _vm._s(tab.label) + "\n        ")]
            )
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }